import {React} from '@api'
import { ErrorInfo } from "react";
import { CLASSES } from "../Types";

/** @hidden @internal */
export interface IErrorBoundaryProps {
    message: string;
}
/** @hidden @internal */
export interface IErrorBoundaryState {
    hasError: boolean;
}

/** @hidden @internal */
export class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.debug(error);
        console.debug(errorInfo);
        //debugger
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={CLASSES.FLEXLAYOUT__ERROR_BOUNDARY_CONTAINER}>
                    <div className={CLASSES.FLEXLAYOUT__ERROR_BOUNDARY_CONTENT}>{this.props.message}</div>
                </div>
            );
        }

        return this.props.children;
    }
}



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/ErrorBoundary.tsx